/**
 * Parse transcript timecodes from Brooklyn (seconds or HH:MM:SS / MM:SS strings).
 */

/** Convert a timecode string to seconds, or null when unparseable. */
export function parseTimecodeToSeconds (timecode: string | null | undefined): number | null {
  if (timecode == null) {
    return null
  }

  const trimmed = String(timecode).trim()
  if (!trimmed) {
    return null
  }

  if (trimmed.includes(':')) {
    const parts = trimmed.split(':').map((part) => Number.parseFloat(part))
    if (parts.some((part) => !Number.isFinite(part))) {
      return null
    }

    if (parts.length === 3) {
      const [hours, minutes, seconds] = parts
      return hours * 3600 + minutes * 60 + seconds
    }

    if (parts.length === 2) {
      const [minutes, seconds] = parts
      return minutes * 60 + seconds
    }

    return null
  }

  const seconds = Number.parseFloat(trimmed)
  return Number.isFinite(seconds) ? seconds : null
}

/** Format a timecode for display (M:SS or H:MM:SS). Falls back to raw input when unparseable. */
export function formatTimecodeDisplay (timecode: string | null | undefined): string {
  if (timecode == null || String(timecode).trim() === '') {
    return '—'
  }

  const raw = String(timecode).trim()
  const seconds = parseTimecodeToSeconds(raw)
  if (seconds == null) {
    return raw
  }

  const total = Math.max(0, Math.floor(seconds))
  const hours = Math.floor(total / 3600)
  const minutes = Math.floor((total % 3600) / 60)
  const secs = total % 60

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
  }

  return `${minutes}:${String(secs).padStart(2, '0')}`
}
